import { Toast } from "mint-ui";
import Vue from "vue";
import "@/tools/common";
import { find } from "lodash";
import getUa from "@/utils/getUa";
import { getStorageData } from '../utils';
import xiaozhuLogo from "@/static/images/miniLogo.png";
Vue.prototype.needLoadMoreTalk = true;
Vue.prototype.imHisList = true;
Vue.prototype.userInfo = getStorageData('userInfo');
window.local_ok = true;
if (!window.localStorage || !window.sessionStorage) {
  window.local_ok = false;
} else {
  try {
    localStorage.setItem("localStorageTest", "1");
    localStorage.removeItem("localStorageTest");
  } catch (e) {
    window.local_ok = false;
  }
}
/* base64 解码 */
function base64_decode(str) {
  var c1, c2, c3, c4;
  var base64DecodeChars = new Array(
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    62,
    -1,
    -1,
    -1,
    63,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    -1,
    -1,
    -1,
    -1,
    -1
  );
  var i = 0;
  var len = str.length;
  var string = "";

  while (i < len) {
    do {
      c1 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
    } while (i < len && c1 == -1);

    if (c1 == -1) break;

    do {
      c2 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
    } while (i < len && c2 == -1);

    if (c2 == -1) break;

    string += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));

    do {
      c3 = str.charCodeAt(i++) & 0xff;
      if (c3 == 61) return string;

      c3 = base64DecodeChars[c3];
    } while (i < len && c3 == -1);

    if (c3 == -1) break;

    string += String.fromCharCode(((c2 & 0xf) << 4) | ((c3 & 0x3c) >> 2));

    do {
      c4 = str.charCodeAt(i++) & 0xff;
      if (c4 == 61) return string;
      c4 = base64DecodeChars[c4];
    } while (i < len && c4 == -1);

    if (c4 == -1) break;

    string += String.fromCharCode(((c3 & 0x03) << 6) | c4);
  }
  return string;
}
const formatDateTime = function(inputTime, type) {
  const date = new Date(inputTime);
  const y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;

  const thisYear = new Date().getFullYear();
  switch (type) {
    case "hm":
      return h + ":" + minute;
      break;
    case "md":
      return m + "." + d;
      break;
    case "ymd":
      if (thisYear == y) {
        return m + "." + d;
      } else {
        return y + "." + m + "." + d;
      }
      break;
    case "ymdhm":
      if (thisYear == y) {
        return m + "." + d + " " + h + ":" + minute;
      } else {
        return y + "." + m + "." + d + " " + h + ":" + minute;
      }
      break;
  }
  return y + "." + m + "." + d + " " + h + ":" + minute + ":" + second;
};
const formatLastMsgShowTime = function(lastMsgtimeStamp) {
  let timestamp = Date.parse(new Date());
  lastMsgtimeStamp = lastMsgtimeStamp * 1000;
  timestamp = timestamp;
  const dd = new Date();
  const diffday = dd.datediff(
    "d",
    parseInt(timestamp),
    parseInt(lastMsgtimeStamp)
  );
  switch (diffday) {
    case 0:
    case -0:
      return formatDateTime(lastMsgtimeStamp, "hm");
      break;
    case 1:
      return "昨天";
      break;
    case 2:
      return "前天";
      break;
    default:
      return formatDateTime(lastMsgtimeStamp, "ymd");
      break;
  }
};
Vue.prototype.synTalkMsgFinish = false;
export const localkey = {
  sessionId: "im_sessionId",
  synMinTime: "im_synMinTime",
  message: "im_message",
  friendlist: "im_friendList",
  userInfo: "im_userInfo",
  luInfo: "im_luInfo"
};
window.joinCb = function(data) {
  if (data.type == "joinAck") {
    const synMinTime = getSynMinTime();
    const synMaxTime = data.timeStamp;
    const paramsData = getUa.userAgent.isLark
      ? {
          synMinTime: synMinTime,
          synMaxTime: synMaxTime,
          bundleType: "biz" // 兼容飞书
        }
      : {
          synMinTime: synMinTime,
          synMaxTime: synMaxTime
        };
    synTalkMsg(paramsData);
  } else {
    Toast(data.errorMsg);
  }
  return data;
};
export var refreshMsgDetail = function(thisMessage) {
  var toUserId = thisMessage.toUserId;
  var fromUserId = thisMessage.fromUserId;
  var luId = thisMessage.luId;
  var localId = thisMessage.localId;
  var pluginType = thisMessage.pluginType;
  var content = thisMessage.content;
  var that = Vue.prototype;
  var friendId = fromUserId == that.userInfo.userId ? toUserId : fromUserId;
  if (pluginType == "chat") {
    var reg1 = new RegExp("\\n", "g");
    var reg2 = new RegExp("\n", "g");
    var reg3 = new RegExp("\\r", "g");
    var reg4 = new RegExp("\r", "g");
    content = content.replace(reg1, "<br/>");
    content = content.replace(reg2, "<br/>");
    content = content.replace(reg3, "<br/>");
    content = content.replace(reg4, "<br/>");
    var emoConv = content.match(/\[[^[]*?\]/g);
    if (emoConv && emoConv.length) {
      for (var j = 0; j < emoConv.length; j++) {
        if (emoConvert(emoConv[j])) {
          content = content.replace(emoConv[j], emoConvert(emoConv[j]));
        }
      }
    }
    if (fromUserId == that.userInfo.userId) {
      var tmp = $(me_meg_detail_tmp);
      tmp.find(".content").html(content);
      tmp.find(".meHeadImg").attr("src", that.userInfo.headImgurl);
    } else {
      var fromUserInfo = that.getLocalStorage(localkey.userInfo + fromUserId);
      var tmp = $(other_meg_detail_tmp);
      tmp.find(".meHeadImg").attr("src", fromUserInfo.headImg);
      tmp.find(".content").html(content);
    }
  } else if (pluginType == "recommend") {
    var recommendJson = JSON.parse(thisMessage.content);
    var fromUserInfo = that.getLocalStorage(localkey.userInfo + fromUserId);
    var tmp = formatRecommendTmp(recommendJson, fromUserInfo);
  } else if (pluginType == "leadWords") {
    var leadWord = thisMessage.content;
    var tmp = formatLeadWordTmp(thisMessage);
  } else if (["botText", "botTextImage", "botBigImage"].includes(pluginType)) {
    var tmp = formatSystemMsgs(thisMessage);
  } else if (pluginType === "tenantform") {
    if (fromUserId == that.userInfo.userId) {
      var tmp = $(me_meg_detail_tmp);
      tmp.find(".meHeadImg").attr("src", that.userInfo.headImgurl);
    } else {
      var tmp = $(other_meg_detail_tmp);
      var fromUserInfo = that.getLocalStorage(localkey.userInfo + fromUserId);
      tmp.find(".meHeadImg").attr("src", fromUserInfo.headImg);
    }
    tmp.find(".content").html(filterTenantMsg(JSON.parse(thisMessage.content)));
  }
  if ($("#" + localId).length > 0) {
    $("#" + localId)
      .find(".load_icon")
      .hide();
  } else {
    if (thisMessage.createTime - __lastMsgTimeStamp > 60 * 5) {
      var time = formatMsgDetailShowTime(thisMessage.createTime);
      $("#msgDetail").append('<li class="imv2_date">' + time + "</li>");
    }
    __lastMsgTimeStamp = thisMessage.createTime;
    $("#msgDetail").append(tmp);
    $(document).scrollTop(1000000);
  }
  setTalkIsRead(friendId, luId);
};
var formatLeadWordTmp = function(bizCmd) {
  var leadWord = bizCmd.content;
  var objType = bizCmd.objType;
  var objId = bizCmd.objId;
  var tmp = $(leadWord_meg_detail_tmp);
  leadWord = leadWord.replace("\\n", "<br/>");
  leadWord = leadWord.replace("\n", "<br/>");
  if (objType == "Bookorder") {
    var href = "/#/order/orderDetail?orderId=" + objId;
    leadWord = leadWord.replace(
      "+{",
      '<a class="color_pinkff" href="' + href + '">'
    );
    leadWord = leadWord.replace("}+", "</a>");
  }
  tmp.find(".imv2_guide_state").html(leadWord);
  return tmp;
};
export var rendNewMsg = function(newMsg) {
  if (!newMsg) return false;
  const currentUserId = Vue.prototype.getUrlParms(window.location.href).fromid;
  const currentLuId = Vue.prototype.getUrlParms(window.location.href).luId;
  const that = Vue.prototype;
  const {
    type,
    fromUserId,
    toUserId,
    luId,
    isRead,
    content,
    createTime,
    pluginType
  } = newMsg;
  const matchHash = window.location.hash.slice(0, 7);
  const friendId = fromUserId == that.userInfo.userId ? toUserId : fromUserId;
  switch (type) {
    case "chat":
      if (matchHash === "#/chatV" || matchHash === "#/chatL") {
        const friendMsgList = $("#" + friendId + luId);
        if (friendMsgList.length > 0) {
          if (pluginType == "chat") {
            friendMsgList.find(".lastMsg").text(content);
          } else if (pluginType == "recommend") {
            var recommendJson = JSON.parse(content);
            friendMsgList
              .find(".lastMsg")
              .text("[推荐房源]" + recommendJson.name);
          } else if (
            ["botText", "botTextImage", "botBigImage"].includes(pluginType)
          ) {
            const recommendJson = JSON.parse(content);
            let { text } = recommendJson;
            if (text) {
              text = filterText(text);
              for (const str of [",", "，"]) {
                const _index = text.indexOf(str);
                if (_index !== -1) {
                  text = text.slice(0, _index);
                  break;
                }
              }
            } else if (pluginType === "botBigImage") {
              text = "[图片]";
            }
            friendMsgList.find(".lastMsg").html(text);
            // 兼容老表单消息
          } else if (pluginType === "tenantform") {
            const recommendJson = JSON.parse(content);
            friendMsgList.find(".lastMsg").text(filterTenantMsg(recommendJson));
          }
          var unReadCount = friendMsgList.find(".unReadCount").text();
          if (!unReadCount) {
            unReadCount = 0;
          }
          if (!isRead || isRead == 0) {
            parseInt(unReadCount) + 1 > 99
              ? (unReadCount = 99)
              : (unReadCount = parseInt(unReadCount) + 1);
            friendMsgList
              .find(".unReadCount")
              .text(unReadCount)
              .show();
          }
          $("#msglist").prepend(friendMsgList);
        } else if (
          ["botText", "botTextImage", "botBigImage"].includes(pluginType)
        ) {
          getInfoOfTalk(friendId + "_" + luId + ",", null, null, newMsg);
        }
      } else if (
        ["#/robot", "#/chat?"].includes(matchHash) &&
        friendId == currentUserId &&
        luId == currentLuId
      ) {
        refreshMsgDetail(newMsg);
      }
      break;
    case "bizcmd":
      if (["#/robot", "#/chat?"].includes(matchHash)) {
        var command = newMsg.command;
        var userRole = newMsg.userRole;
        var decodeCommand = JSON.parse(base64_decode(command));
        if (decodeCommand && decodeCommand.type == "imleadword") {
          var params = decodeCommand.params;
          var leadWord = params.leadWord;
          leadWord = decodeURI(leadWord);
          var data = {
            type: "chat",
            pluginType: "leadWords",
            content: leadWord,
            fromUserId: params.landlordId,
            luId: params.luId,
            objType: params.objType,
            objId: params.objId
          };

          refreshMsgDetail(data);
          dealWithTheImData(data, false);
        }
      }
      break;
  }
};

function synTalkMsg(params) {
  const that = Vue.prototype;
  that.$get(apiUrl + "im/synTalkMsg", params).then(response => {
    if (response.status == 200) {
      const message = response.content.synTalkMsgRows;
      if (message && message.length > 0) {
        for (let i = 0, length = message.length; i < length; i++) {
          message[i].type = "chat";
          dealWithTheImData(message[i], true);
        }
      }
      const friendList = that.getLocalStorage(localkey.friendlist);
      updateFriendStorageInfo(friendList, function() {
        Vue.prototype.synTalkMsgFinish = true;
      });
    } else {
      Toast(response.errorMsg);
    }
  });
}

function getMsg(friendId, luId) {
  const that = Vue.prototype;
  const key = localkey.message;
  const msgList = that.getLocalStorage(key + "_" + friendId + "_" + luId);
  return msgList;
}

function storageMessage(
  friendId,
  luId,
  message,
  needUpdateFriendList,
  isUnshift
) {
  const that = Vue.prototype;
  if (!(friendId && luId)) return false;
  // 只在接到新消息的时候才更新本地存储里的用户列表，并且保持十个
  if (needUpdateFriendList) {
    updateFriendList(friendId, luId);
  }

  const key = localkey.message;
  let lastAllMessage = that.getLocalStorage(key + "_" + friendId + "_" + luId);
  if (!lastAllMessage) {
    lastAllMessage = [];
  } else if (message.msgId) {
    let findDuplicationMsg = false;
    for (let i = 0, length = lastAllMessage.length; i < length; i++) {
      if (lastAllMessage[i].msgId == message.msgId) {
        findDuplicationMsg = true;
        break;
      }
    }
    if (findDuplicationMsg) {
      return false;
    }
  } else {
  }
  const newAllMessage = lastAllMessage;
  if (!message.send && !isUnshift) {
    newAllMessage.unshift(message);
  } else {
    newAllMessage.push(message);
  }

  that.setLocalStorage(key + "_" + friendId + "_" + luId, newAllMessage);
}

function updateFriendList(friendId, luId) {
  const that = Vue.prototype;
  const key = localkey.friendlist;
  let friendlist = that.getLocalStorage(key);
  if (friendlist) {
    for (let i = 0; i < friendlist.length; i++) {
      if (friendlist[i] === friendId + "_" + luId) {
        friendlist.splice(i, 1);
        break;
      }
    }
    friendlist.unshift(friendId + "_" + luId);
    friendlist = friendlist.slice(0, 10);
    that.setLocalStorage(key, friendlist);
  } else {
    that.setLocalStorage(key, [friendId + "_" + luId]);
  }
}

export function dealWithTheImData(message, needUpdateFriendList, needBefore) {
  const that = Vue.prototype;
  const type = message.type;
  switch (type) {
    case "chat":
      const antiSpam = message.antiSpam;
      const content = message.content;
      const createTime = message.createTime;
      const fromUserClientType = message.fromUserClientType;
      const fromUserId = message.fromUserId;
      const isRead = message.isRead;
      const landlordId = message.landlordId;
      const localId = message.localId;
      const luId = message.luId;
      const msgId = message.msgId;
      const pluginType = message.pluginType;
      const seq = message.seq;
      const toUserId = message.toUserId;

      const synMinTime = that.getLocalStorage(localkey.synMinTime);
      if (synMinTime < createTime)
        that.setLocalStorage(localkey.synMinTime, createTime);
      if (that.userInfo.userId == fromUserId) {
        var friendId = toUserId;
      } else {
        var friendId = fromUserId;
      }
      let isLocalMessage = false;
      const allMsg = getMsg(friendId, luId);
      if (allMsg) {
        for (let i = 0, length = allMsg.length; i < length; i++) {
          const thisMessgae = allMsg[i];
          const thisPluginType = thisMessgae.pluginType;
          if (thisPluginType != "leadWords") {
            const thisLocalId = thisMessgae.localId;
            if (localId == thisLocalId) {
              allMsg[i].msgId = msgId;
              isLocalMessage = true;
              break;
            }
          }
        }
      }
      if (!isLocalMessage && needBefore) {
        storageMessage(friendId, luId, message, needUpdateFriendList, true);
      } else if (!isLocalMessage) {
        storageMessage(friendId, luId, message, needUpdateFriendList);
      } else {
        const key = localkey.message;
        if (!allMsg) {
          that.setLocalStorage(key + "_" + friendId + "_" + luId, "");
        } else {
          that.setLocalStorage(key + "_" + friendId + "_" + luId, allMsg);
        }
      }
      break;
    case "bizcmd":
      break;
    default:
      reminderMsg(message);
      break;
  }
}
export const reminderMsg = function(message) {
  if (message.p_event == "info") {
    var jumpStr = "#";
    var remindMsg = "";
    if (message.p_reserve1) {
      jumpStr = message.p_reserve1;
      remindMsg =
        '<div class="reminder_msg_box" id="remindMsg" style=""> <a href=" ' +
        jumpStr +
        '">' +
        message.p_shortcontent +
        "</a><p>查看详情</p><i></i></div>";
    } else {
      remindMsg =
        '<div class="reminder_msg_box" id="remindMsg" style=""> <a href=" ' +
        jumpStr +
        '">' +
        message.p_shortcontent +
        "</a><i></i></div>";
    }
    $("div:first").before(remindMsg);
    $("#remindMsg").slideDown("slow");
    setTimeout(function() {
      $("#remindMsg").animate(
        {
          top: "-100px"
        },
        "slow",
        function() {
          $("#remindMsg").remove();
        }
      );
    }, 7000);
    // 滑动收起
    var startY = 0;
    $("#remindMsg")
      .on("touchend", function(e) {
        var e = e || window.event;
        var endY = e.originalEvent.changedTouches[0].pageY;
        if (startY - endY > 5) {
          $("#remindMsg").animate(
            {
              top: "-100px"
            },
            "slow",
            function() {
              $("#remindMsg").remove();
            }
          );
        }
      })
      .on("touchstart", function(e) {
        var e = e || window.event;
        startY = e.originalEvent.targetTouches[0].pageY;
      });
  }
};
export function updateFriendStorageInfo(friendList, callback, data) {
  let select_data = "";
  for (let i = 0, length = friendList.length; i < length; i++) {
    const userAndLodgeUnitId = friendList[i].split("_");
    const userId = userAndLodgeUnitId[0];
    const luId = userAndLodgeUnitId[1];
    select_data += userId + "_" + luId + ",";
  }
  if (!select_data) {
    if (callback) {
      callback(data);
    }
    return false;
  }
  getInfoOfTalk(select_data, callback, data);
}

function getInfoOfTalk(params, callback, result, newMsg) {
  const that = Vue.prototype;
  const paramsData = getUa.userAgent.isLark
    ? {
        userAndLodgeUnitIds: params,
        bundleType: "biz" // 兼容飞书
      }
    : {
        userAndLodgeUnitIds: params
      };
  that.$get(apiUrl + "im/getInfoOfTalk", paramsData).then(data => {
    if (data.status == 200) {
      const c = data.content;
      const userInfos = c.userInfo;
      const lodgeUnitInfos = c.lodgeUnitInfo;
      if (userInfos) {
        for (let i = 0, length = userInfos.length; i < length; i++) {
          const userId = userInfos[i].userId;
          that.setLocalStorage(localkey.userInfo + userId, userInfos[i]);
        }
      }

      if (lodgeUnitInfos) {
        for (let j = 0, length = lodgeUnitInfos.length; j < length; j++) {
          const luId = lodgeUnitInfos[j].luId;
          that.setLocalStorage(localkey.luInfo + luId, lodgeUnitInfos[j]);
        }
      }
      if (callback) {
        callback(result);
      }
      if (newMsg) {
        // 服务器首次推送消息
        (function(newMsg) {
          const {
            fromUserId,
            toUserId,
            luId,
            content,
            createTime,
            pluginType
          } = newMsg;
          const friendId =
            that.userInfo.userId === fromUserId ? toUserId : fromUserId;
          const userInfo = userInfos && userInfos[0];
          const lodgeUnitInfo = lodgeUnitInfos && lodgeUnitInfos[0];
          var luTips = "";
          const tmp = $(msglist_tmp);
          tmp
            .attr("userid", userInfo.userId)
            .attr("luid", lodgeUnitInfo.luId)
            .attr("objType", lodgeUnitInfo.objType)
            .attr("id", friendId + luId);
          tmp.attr("onclick", "goChat(this)");
          // tmp.find('.imv2_user_name').text(userInfo.nickName);
          if (that.imBotLuIds.includes(luId)) {
            luTips = "这是一个会推荐房源、推送福利的小家伙";
          } else if (lodgeUnitInfo.state == "deleted") {
            luTips = "房源已删除";
          } else if (lodgeUnitInfo.state == "online") {
            luTips = userInfo.nickName + " · " + lodgeUnitInfo.luName;
          } else if (lodgeUnitInfo.objType == "12") {
            luTips = "";
          } else {
            luTips = "房源已下线";
          }
          tmp.find(".im_lodgeunitname").text(luTips);
          tmp.find(".headImg").attr("src", userInfo.headImg);
          const recommendJson = JSON.parse(content);
          let { text } = recommendJson;
          if (text) {
            text = filterText(text);
            for (const str of [",", "，"]) {
              const _index = text.indexOf(str);
              if (_index !== -1) {
                text = text.slice(0, _index);
                break;
              }
            }
          } else if (pluginType === "botBigImage") {
            text = "[图片]";
          }
          tmp.find(".lastMsg").html(text);
          tmp.find("showTime").text(formatLastMsgShowTime(createTime));
          tmp
            .find(".unReadCount")
            .show()
            .text(1);
          $("#msglist").prepend(tmp);
        })(newMsg);
      }
    }
  });
}

function getSynMinTime() {
  const key = localkey.synMinTime;
  let synMinTime = localStorage.getItem(key);
  if (!synMinTime) synMinTime = 0;
  return synMinTime;
}
const msglist_tmp = [
  '<li class="imv2_infolist_item clearfix" >',
  '<div class="headerImg"><img class="headImg" src="" alt="" /><em class="boxShadow"></em></div>',
  '<div class="imv2_infolist_itemR">',
  '<h1 class="clearfix"><em class="showTime"></em></h1>',
  '<h2><span class="imv2_room_detail lastMsg"></span><span class="imv2_info_num unReadCount" style="display:none"></span></h2>',
  '<p class="im_lodgeunitname"></p>',
  "</div>",
  "</li>"
].join("");
var me_meg_detail_tmp = [
  '<li class="msg_detail_one">',
  '<div class="imv2_small_head me"><img src="" alt="" class="meHeadImg"></div>',
  '<div class="imv2_infobox right">',
  '<p class="content"></p>',
  '<span class="arrow"></span>',
  "</div>",
  '<span class="load_icon right" style="display:none"></span>',
  "</li>"
].join("");
var other_meg_detail_tmp = [
  '<li class="msg_detail_one">',
  '<div class="imv2_small_head other"><img src="" alt="" class="meHeadImg"></div>',
  '<div class="imv2_infobox left">',
  '<p class="content"></p>',
  '<span class="arrow"></span>',
  "</div>",
  '<span class="load_icon left" style="display:none"></span>',
  "</li>"
].join("");
var recommend_meg_detail_tmp = [
  '<li class="msg_detail_one">',
  '<div class="imv2_small_head other"><img src="" alt="" class="meHeadImg"></div>',
  '<div class="imv2_infoboxv2 left">',
  '<p class="luImg" ><span class="imv2_room_address luName"></span><span class="imv2_room_price"></span></p>',
  "</div>",
  "</li>"
].join(""); // 引入小猪的logo

// 针对三种系统推送消息 的dom样式

// pluginType

/**
 *
 *  纯文本      botText
 * 文本+图片   botTextImage
 * 大图        botBigImage
 *  @forexample
 *
	botText 类型时 纯文本
	{
	"text": "为您推荐位于{【上海】}的优秀房源，下单即可入住，无需房东确认。",
	"openUrl": "openapp.xzdz://xiaozhu.com/openpage?page=orderList"
	}

	botTextImage 类型时 图文
	{
	"text": "为您推荐位于{【上海】}的优秀房源，下单即可入住，无需房东确认。",
	"imgList": [
		"https://cdn.pixabay.com/photo/2015/03/26/09/47/sky-690293__340.jpg",
		"https://pic.feizl.com/upload/allimg/190620/gxtxugkwn5ldqoz.jpg",
		"https://p.ssl.qhimg.com/dmfd/400_300_/t01477b065093357cd4.jpg"
	],
	"recommendTips": "上海·5套推荐",
	"openUrl": "openapp.xzdz://xiaozhu.com/openpage?page=orderList"
	}

	botBigImage 类型时 大图
	{
	"imgUrl": "http://image.topit.cc/uploads/20180304/10/1520130079-YGNyIrsRqp.jpg",
	"openUrl": "openapp.xzdz://xiaozhu.com/openpage?page=orderList"
	}
 */
// botText
var text_msg_detail_tmp = [
  '<li class="msg_detail_one">',
  '<div class="imv2_small_head other"><img src alt="" class="meHeadImg"></div>',
  '<div class="imv2_infobox left bot-text-container">',
  '<p class="content"></p>',
  '<span class="arrow"></span>',
  "</div>",
  '<span class="load_icon left" style="display:none"></span>',
  "</li>"
].join("");

// botTextImage

var textImage_msg_detail_tmp = [
  '<li class="msg_detail_one">',
  '<div class="imv2_small_head other"><img  src alt="" class="meHeadImg"></div>',
  '<div class="imv2_infobox left text-image-container">',
  '<a class="jumpImg" href>',
  '<div class="content-box">',
  '<p class="content"></p>',
  "</div>",
  '<div class="recommend-img-container">',
  '<div class="left-box">',
  '<img src="" alt class="firstImage">',
  "</div>",
  '<div class="right-box">',
  '<img src="" alt class="secondImage">',
  '<img src="" alt class="thirdImage">',
  "</div>",
  "</div>",
  '<div class="recommend-room">',
  '<span class="tip-content"></span>',
  '<span class="tip-arrow"></span>',
  "</div>",
  '<span class="arrow"></span>',
  "</a>",
  "</div>",
  '<span class="load_icon left" style="display:none"></span>',
  "</li>"
].join("");

// botBigImage
var bigImage_msg_detail_tmp = [
  '<li class="msg_detail_one">',
  '<div class="imv2_small_head other"><img src alt="" class="meHeadImg"></div>',
  '<div class="imv2_infobox left big-image-container">',
  '<a href class="jumpBox"><img src alt class="bigImage"></a>',
  '<span class="arrow"></span>',
  "</div>",
  '<span class="load_icon left" style="display:none"></span>',
  "</li>"
].join("");

export var leadWord_meg_detail_tmp = [
  '<li class="lead_word"><div class="imv2_guide_state"></div></li>'
].join("");

function getLastMsg(friendId, luId) {
  const key = localkey.message;
  const msgList = Vue.prototype.getLocalStorage(
    key + "_" + friendId + "_" + luId
  );
  if (!msgList) return "";
  let lastMsg = "";
  for (let i = msgList.length - 1; i >= 0; i--) {
    if (msgList[i].pluginType != "leadWords") {
      lastMsg = msgList[i];
      break;
    }
  }
  // let lastMsg = msgList[msgList.length-1];
  return lastMsg;
}

function getUnReadMsgCount(friendId, luId) {
  const msgList = Vue.prototype.getLocalStorage(
    localkey.message + "_" + friendId + "_" + luId
  );
  const LocalUserInfo = Vue.prototype.getLocalStorage("userInfo");
  let unReadCount = 0;
  for (let i = 0, length = msgList.length; i < length; i++) {
    if (
      msgList[i].fromUserId != LocalUserInfo.userId &&
      msgList[i].isRead == 0
    ) {
      unReadCount++;
    }
  }
  return unReadCount;
}
// 更新信息
export function updateMsgList(friendLists) {
  if (friendLists.length) {
    $("#no_message").hide();
  }
  const that = Vue.prototype;
  const tmpArr = [];
  const createTimeArr = [];
  const friendList = friendLists;
  for (let i = 0, length = friendList.length; i < length; i++) {
    const userAndLodgeUnitId = friendList[i].split("_");
    const userId = userAndLodgeUnitId[0];
    const luId = userAndLodgeUnitId[1];
    const userInfo = that.getLocalStorage(localkey.userInfo + userId);
    const lodgeUnitInfo = that.getLocalStorage(localkey.luInfo + luId);
    const tmp = $(msglist_tmp);
    let luTips = "";
    const lastMsg = getLastMsg(userId, luId);
    const msgId = lastMsg.msgId;
    const pluginType = lastMsg.pluginType;
    tmp
      .attr("userid", userInfo.userId)
      .attr("luid", lodgeUnitInfo.luId)
      .attr("objType", lodgeUnitInfo.objType)
      .attr("id", userId + luId);
    tmp.attr("onclick", "goChat(this)");
    // tmp.find('.imv2_user_name').text(userInfo.nickName);
    // let chatListArr = [];
    if (that.imBotLuIds.includes(luId)) {
      luTips = "这是一个会推荐房源、推送福利的小家伙";
    } else if (lodgeUnitInfo.state == "deleted") {
      luTips = "房源已删除";
    } else if (lodgeUnitInfo.state == "online") {
      luTips = userInfo.nickName + " · " + lodgeUnitInfo.luName;
    } else if (lodgeUnitInfo.objType == "12") {
      luTips = userInfo.nickName;
    } else {
      luTips = "房源已下线";
    }
    tmp.find(".im_lodgeunitname").text(luTips);
    tmp.find(".headImg").attr("src", userInfo.headImg);

    if (pluginType == "chat") {
      const lastMsgContent = lastMsg.content;
      tmp.find(".lastMsg").text(lastMsgContent);
    } else if (pluginType == "recommend") {
      const recommendJson = JSON.parse(lastMsg.content);
      tmp.find(".lastMsg").text("[推荐房源]" + recommendJson.name);
    } else if (
      ["botText", "botTextImage", "botBigImage"].includes(pluginType)
    ) {
      const recommendJson = JSON.parse(lastMsg.content);
      let { text } = recommendJson;
      if (text) {
        text = filterText(text);
        for (const str of [",", "，"]) {
          const _index = text.indexOf(str);
          if (_index !== -1) {
            text = text.slice(0, _index);
            break;
          }
        }
      } else if (pluginType === "botBigImage") {
        text = "[图片]";
      }
      tmp.find(".lastMsg").html(text);
      // 兼容老表单消息
    } else if (pluginType === "tenantform") {
      const recommendJson = JSON.parse(lastMsg.content);
      tmp.find(".lastMsg").text(filterTenantMsg(recommendJson));
    }
    if (!msgId) {
      // 发送失败
      tmp
        .find(".lastMsg")
        .html(
          '<i class="imv2_remind_icon iconfont xzFontColor">&#xe749;</i>' +
            tmp.find(".lastMsg").text()
        );
    }
    const storeContent = Vue.prototype.getLocalStorage(
      "msg_content_" + userId + luId
    );
    if (storeContent) {
      // 草稿
      tmp
        .find(".lastMsg")
        .html(
          '<i class="imv2_input_icon iconfont">&#xe824;</i>' + storeContent
        );
    }

    const createTime = lastMsg.createTime;
    const showTime = formatLastMsgShowTime(createTime);
    tmp.find(".showTime").text(showTime);

    let unReadCount = getUnReadMsgCount(userId, luId);
    if (unReadCount) {
      // 私信tab加入小红点
      $("#chatTabIndex2").show();
      if (unReadCount > 99) unReadCount = 99;
      tmp
        .find(".unReadCount")
        .show()
        .text(unReadCount);
    }

    tmpArr[createTime] = tmp;
    createTimeArr.push(createTime);
  }

  createTimeArr.sort(function(x, y) {
    return y - x;
  });
  for (let k = 0, length = createTimeArr.length; k < length; k++) {
    const currTmp = tmpArr[createTimeArr[k]];
    const userId = currTmp.attr("userid") || "";
    const luId = currTmp.attr("luid") || "";
    if (userId && luId && $("#" + userId + luId).length > 0) {
      $("#" + userId + luId).replaceWith(currTmp);
      continue;
    }
    $("#msglist").append(currTmp);
  }
}

export function goChat(that) {
  const _vue = Vue.prototype;
  Vue.prototype.imHisList = true;
  const fromId = $(that).attr("userid");
  const luId = $(that).attr("luid");
  const objType = $(that).attr("objType");
  const lodgeBusiness = objType == "12" ? "store" : "";
  const _href = _vue.imBotLuIds.includes(luId)
    ? `${window.location.origin}/#/robot?fromid=${fromId}&luId=${luId}&lodgeBusiness=${lodgeBusiness}`
    : `${window.location.origin}/#/chat?fromid=${fromId}&luId=${luId}&lodgeBusiness=${lodgeBusiness}`;

  window.location.href = _href;
}
let emoinfo = "";
if (window.local_ok == true) {
  emoinfo = Vue.prototype.getLocalStorage("emoinfo");
} else {
  $.get(
    "static/json/emotion.json",
    function(datas) {
      emoinfo = datas;
    },
    "json"
  );
}
if (!emoinfo) {
  $.get(
    "static/json/emotion.json",
    function(datas) {
      if (window.local_ok == true) {
        Vue.prototype.setLocalStorage("emoinfo", datas);
      }
      emoinfo = datas;
    },
    "json"
  );
}
const emoConvert = function(emo) {
  if (!emoinfo[0]) return emo;
  const emokey = emoinfo[0].indexOf(emo.slice(1, -1));
  if (emokey >= 0) {
    return (
      '<img class="emo_display" style="width:25px;height:25px;margin:0;display:inline-block" src="' +
      emoinfo[1][emokey] +
      '" key="' +
      emokey +
      '" />'
    );
  } else {
    return false;
  }
};

function formatMsgDetailShowTime(lastMsgtimeStamp) {
  var timestamp = Date.parse(new Date());
  lastMsgtimeStamp = lastMsgtimeStamp * 1000;
  timestamp = timestamp;
  var dd = new Date();
  var diffday = dd.datediff(
    "d",
    parseInt(timestamp),
    parseInt(lastMsgtimeStamp)
  );
  switch (diffday) {
    case 0:
    case -0:
      return formatDateTime(lastMsgtimeStamp, "hm");
      break;
    case 1:
      return "昨天" + formatDateTime(lastMsgtimeStamp, "hm");
      break;
    case 2:
      return "前天" + formatDateTime(lastMsgtimeStamp, "hm");
      break;
    default:
      return formatDateTime(lastMsgtimeStamp, "ymdhm");
      break;
  }
}
var __lastMsgTimeStamp = 0;
export const formatMsgDetailTmp = function(allMessages, pendType) {
  var that = Vue.prototype;
  let allTmp = "";
  var allMessage = allMessages;
  if (allMessage) {
    __lastMsgTimeStamp = 0;
    for (let i = 0, length = allMessage.length; i < length; i++) {
      const thisMessage = allMessage[i];
      const msgId = thisMessage.msgId;
      const toUserId = thisMessage.toUserId;
      const fromUserId = thisMessage.fromUserId;
      const pluginType = thisMessage.pluginType;
      if (pluginType == "chat") {
        let content = thisMessage.content;
        const reg1 = new RegExp("\\n", "g");
        const reg2 = new RegExp("\n", "g");
        const reg3 = new RegExp("\\r", "g");
        const reg4 = new RegExp("\r", "g");
        content = content.replace(reg1, "<br/>");
        content = content.replace(reg2, "<br/>");
        content = content.replace(reg3, "<br/>");
        content = content.replace(reg4, "<br/>");
        const emoConv = content.match(/\[[^[]*?\]/g);
        if (emoConv && emoConv.length) {
          for (let j = 0; j < emoConv.length; j++) {
            if (emoConvert(emoConv[j])) {
              content = content.replace(emoConv[j], emoConvert(emoConv[j]));
            }
          }
        }
        if (fromUserId == that.userInfo.userId) {
          var tmp = $(me_meg_detail_tmp);
          if (!msgId) {
            tmp
              .find(".load_icon")
              .removeClass("load_icon")
              .addClass("nosend_icon")
              .show();
          }
          tmp.find(".content").html(content);
          tmp.find(".meHeadImg").attr("src", that.userInfo.headImgurl);
        } else {
          const fromUserInfo = that.getLocalStorage(
            localkey.userInfo + fromUserId
          );
          var tmp = $(other_meg_detail_tmp);
          tmp.find(".meHeadImg").attr("src", fromUserInfo.headImg);
          tmp.find(".content").html(content);
        }
      } else if (pluginType == "recommend") {
        const recommendJson = JSON.parse(thisMessage.content);
        const fromUserInfo = that.getLocalStorage(
          localkey.userInfo + fromUserId
        );
        var tmp = formatRecommendTmp(recommendJson, fromUserInfo);
      } else if (pluginType == "leadWords") {
        const leadWord = thisMessage.content;
        var tmp = formatLeadWordTmp(thisMessage);
      } else if (
        ["botText", "botTextImage", "botBigImage"].includes(pluginType)
      ) {
        var tmp = formatSystemMsgs(thisMessage);
      } else if (pluginType === "tenantform") {
        if (fromUserId == that.userInfo.userId) {
          var tmp = $(me_meg_detail_tmp);
          tmp.find(".meHeadImg").attr("src", that.userInfo.headImgurl);
        } else {
          var tmp = $(other_meg_detail_tmp);
          var fromUserInfo = that.getLocalStorage(
            localkey.userInfo + fromUserId
          );
          tmp.find(".meHeadImg").attr("src", fromUserInfo.headImg);
        }
        tmp
          .find(".content")
          .html(filterTenantMsg(JSON.parse(thisMessage.content)));
      }
      if (thisMessage.createTime - __lastMsgTimeStamp > 60 * 5) {
        let time = formatMsgDetailShowTime(thisMessage.createTime);
        time = $('<li class="imv2_date">' + time + "</li>");
        allTmp += time[0].outerHTML;
      }
      __lastMsgTimeStamp = thisMessage.createTime;
      if (tmp) {
        allTmp += tmp[0].outerHTML;
      }
    }
  }
  return allTmp;
};

function getMsgByPage(friendId, luId, offset, length) {
  const that = Vue.prototype;
  var key = localkey.message;
  var msgList = that.getLocalStorage(key + "_" + friendId + "_" + luId);
  // msgList = msgList.reverse()
  var msgLength = msgList.length;
  if (offset > msgLength) return false;
  var pageMsg = [];
  for (var i = 0; i < msgLength; i++) {
    if (!msgList[i]) break;
    var pluginType = msgList[i].pluginType;
    if (i < msgLength - offset && i >= msgLength - length - offset) {
      pageMsg.push(msgList[i]);
    }
  }
  return pageMsg;
}
// 初始化消息详情页
export function initMsgDetailPage(userId, luId) {
  var currentUserId = Vue.prototype.getUrlParms(window.location.href).fromid;
  var currentLuId = Vue.prototype.getUrlParms(window.location.href).luId;
  var that = Vue.prototype;
  if (!userId && !luId) {
    userId = currentUserId;
    luId = currentLuId;
  }
  const storeContent = Vue.prototype.getLocalStorage(
    "msg_content_" + userId + luId
  );
  if (storeContent) {
    $("#msgContent")
      .val(storeContent)
      .trigger("keyup");
    $("#sendMsgBtn").addClass("msgsend_btn_pink");
  } else {
    $("#msgContent")
      .val("")
      .trigger("keyup");
    $("#sendMsgBtn").removeClass("msgsend_btn_pink");
  }

  const nowOffset = 10;
  $("#msgDetail")
    .find(".msg_detail_one")
    .remove();
  $("#msgDetail")
    .find(".imv2_date")
    .remove();
  $("#msgDetail")
    .find(".lead_word")
    .remove();

  const luInfo = that.getLocalStorage(localkey.luInfo + luId);
  if (
    luInfo &&
    luInfo.leaseType &&
    luInfo.price &&
    luInfo.luImg &&
    luInfo.objType != "12"
  ) {
    $("#msgdetail_luimg").attr("src", luInfo.luImg);
    $("#msgdetail_luname").text(luInfo.luName);
    $("#msgdetail_ludetail").html(
      luInfo.leaseType + "-" + "&yen;" + luInfo.price + "/晚"
    );
  } else {
    $("#msg-detail-top").hide();
  }

  const allMessage = getMsgByPage(userId, luId, 0, 10);
  const msgTmps = formatMsgDetailTmp(allMessage);
  setTalkIsRead(userId, luId);
  $("#msgDetail").append(msgTmps);
  setTimeout(function() {
    $(document).scrollTop(1000000);
  }, 500);
}

function talkMsgSetRead(tenantId, luId, isTenant) {
  const that = Vue.prototype;
  const params = getUa.userAgent.isLark
    ? {
        tenantId: tenantId,
        luId: luId,
        isTenant: isTenant,
        bundleType: "biz" // 兼容飞书
      }
    : {
        tenantId: tenantId,
        luId: luId,
        isTenant: isTenant
      };
  that.$get(apiUrl + "im/talkMsgSetRead", params).then(response => {});
}

function getTalkRead(friendId, luId) {
  const that = Vue.prototype;
  const msgList = getMsg(friendId, luId);
  if (msgList) {
    for (let i = 0, length = msgList.length; i < length; i++) {
      msgList[i].isRead = 1;
    }
  }
  const key = localkey.message;
  if (msgList) {
    that.setLocalStorage(key + "_" + friendId + "_" + luId, msgList);
  } else {
    that.setLocalStorage(key + "_" + friendId + "_" + luId, "");
  }
}

function setTalkIsRead(friendId, luId) {
  const isTenant = "1";
  const tenantId = Vue.prototype.userInfo.userId;
  talkMsgSetRead(tenantId, luId, isTenant);
  getTalkRead(friendId, luId);
  const ele = $("#" + friendId + luId);
  if (ele.length > 0) {
    ele
      .find(".unReadCount")
      .text(0)
      .hide();
  }
}
var startX = 0;
var startY = 0;
var needLoadMoreMessage = false;
var needLoadMoreNotice = false;
var nowOffset = 10;
export function touchStart(evt) {
  try {
    var touch = evt.touches[0];
    var x = Number(touch.pageX);
    var y = Number(touch.pageY);
    startX = x;
    startY = y;
  } catch (e) {}
}
// 加载更多消息
var loadMoreMsgPage = function() {
  var that = Vue.prototype;
  var userId = that.getUrlParms(window.location.href).fromid;
  var luId = that.getUrlParms(window.location.href).luId;
  var allMessage = getMsgByPage(userId, luId, nowOffset, 10);
  nowOffset += 10;
  var msgTmps = formatMsgDetailTmp(allMessage);
  if (msgTmps) {
    $("#msgDetail").prepend(msgTmps);
    return true;
  } else {
    return false;
  }
};
export function touchMove(evt) {
  try {
    var touch = evt.touches[0];
    var x = Number(touch.pageX);
    var y = Number(touch.pageY);
    switch (window.location.hash.slice(0, 7)) {
      case "#/chat?":
      case "#/robot":
        if (y - startY > 0 && document.body.scrollTop == 0) {
          $("#msgdetail_loading").show();
          needLoadMoreMessage = true;
        }
        break;
      case "":
        var scrollTop = $(document).scrollTop();
        var windowHeight = $(window).height();
        var docHeight = $(document).height();
        if (scrollTop + windowHeight > docHeight - 100) {
          Vue.prototype.needLoadMoreTalk = true;
        }
        break;
      default:
        return false;
        break;
    }
  } catch (e) {}
}
export function touchEnd(evt) {
  switch (window.location.hash.slice(0, 7)) {
    case "#/chat?":
    case "#/robot":
      setTimeout(function() {
        $("#msgdetail_loading").hide();
        if (needLoadMoreMessage) {
          var loadMoreResult = loadMoreMsgPage();
          if (!loadMoreResult) {
            $("#msgdetail_nomoremsg").show();
            setTimeout(function() {
              $("#msgdetail_nomoremsg").hide();
            }, 1000);
          }
        }
        needLoadMoreMessage = false;
      }, 1000);
      break;
    case "#/chatV":
      setTimeout(function() {
        if (Vue.prototype.needLoadMoreTalk && Vue.prototype.imHisList) {
          var currentTalkCnt = $("#msglist").children().length;
          var isTenant = 1;
          moreFriendList = [];
          talkHis(isTenant, currentTalkCnt, 10);
        }
        Vue.prototype.needLoadMoreTalk = false;
      }, 1000);
      break;
    case "#/chatL":
      setTimeout(function() {
        if (Vue.prototype.needLoadMoreTalk && Vue.prototype.imHisList) {
          var currentTalkCnt = $("#msglist").children().length;
          var isTenant = 1;
          moreFriendList = [];
          talkHis(isTenant, currentTalkCnt, 10);
        }
        Vue.prototype.needLoadMoreTalk = false;
      }, 1000);
      break;
    default:
      break;
  }

  function talkHis(isTenant, offset, length) {
    const params = getUa.userAgent.isLark
      ? {
          isTenant: isTenant,
          offset: offset,
          length: length,
          bundleType: "biz" // 兼容飞书
        }
      : {
          isTenant: isTenant,
          offset: offset,
          length: length
        };
    Vue.prototype.$get(`${apiUrl}im/talkHis`, params).then(res => {
      Vue.prototype.needLoadMoreTalk = true;
      const data = res;
      if (data.status == 200) {
        var c = data.content;
        Vue.prototype.imHisList = !!c;
        if (!c) {
          return false;
        }
        for (var talkId in c) {
          for (var i = 0, length = c[talkId].length; i < length; i++) {
            var thisMsg = c[talkId][i];
            thisMsg.type = "chat";
            dealWithTheImData(thisMsg, false);
            if (thisMsg.fromUserId == Vue.prototype.userInfo.userId) {
              var friendId = thisMsg.toUserId;
            } else {
              var friendId = thisMsg.fromUserId;
            }
            var luId = thisMsg.luId;
            talkHisFriendList(friendId, luId);
          }
        }
        updateFriendStorageInfo(moreFriendList, updateMsgList, moreFriendList);
        // updateMsgList(moreFriendList);
      } else if (data.errorMsg) Toast(data.errorMsg);
    });
  }
  var moreFriendList = [];
  var talkHisFriendList = function(friendId, luId) {
    if (moreFriendList) {
      for (var i = 0; i < moreFriendList.length; i++) {
        if (moreFriendList[i] === friendId + "_" + luId) {
          moreFriendList.splice(i, 1);
          break;
        }
      }
      moreFriendList.unshift(friendId + "_" + luId);
    } else {
      moreFriendList = [friendId + "_" + luId];
    }
  };
}
export const goSearch = function(that) {
  const luId = $(that).attr("luid");
  // 删除日期缓存；
  localStorage.removeItem("setData");
  window.location.href = `${location.protocol}//${location.host}/#/detail?luId=${luId}`;
};
export const formatRecommendTmp = function(recommendJson, friendInfo) {
  var tmp = $(recommend_meg_detail_tmp);
  var luId = recommendJson.luid;
  var image = recommendJson.image;
  var name = recommendJson.name;
  var price = 0;
  if (recommendJson.showPrice && recommendJson.showPrice.showPrice) {
    price = recommendJson.showPrice.showPrice;
  } else if (recommendJson.showPrice && recommendJson.showPrice.price) {
    price = recommendJson.showPrice.price;
  }
  tmp.find(".imv2_room_price").text("整套-￥" + price + "/晚");
  tmp.find(".luName").text(name);
  tmp
    .find(".luImg")
    .attr("luid", luId)
    .prepend('<img src="' + image + '"/>');
  tmp.find(".luImg").attr("onclick", "goSearch(this)");
  tmp.find(".meHeadImg").attr("src", friendInfo.headImg);
  return tmp;
};

/**
 * @description 过滤消息类型 封装dom
 *
 * @param {*} msg 通过服务器推送的消息
 *
 */
export function formatSystemMsgs(msg) {
  /**
   *  @param {String} toUserId 接收方的id
   *  @param {String} fromUserId 发送方的id
   *  @param {String} fromUserClientType 发送方的客户端类型
   *  @param {Json <String>} content 新的消息对象
  		// text    {String}发送的正文
  		// h5OpenUrl {String <link>} h5跳转的地址
  		// imgList {Array} 图像数组
  		// recommendTips {String} 推荐备注信息
  */
  const { toUserId, fromUserId, pluginType, content } = msg;
  let tmp;

  const { text, h5OpenUrl, imgList, imgUrl, recommendTips } =
    (content && JSON.parse(content)) || {};
  switch (pluginType) {
    case "botText":
      tmp = $(text_msg_detail_tmp);
      break;
    case "botTextImage":
      tmp = $(textImage_msg_detail_tmp);
      tmp
        .find(".firstImage")
        .attr("src", imgList[0])
        .parent()
        .next()
        .children(".secondImage")
        .attr("src", imgList[1])
        .next()
        .attr("src", imgList[2]);
      tmp.find(".tip-content").text(recommendTips);
      break;
    case "botBigImage":
      tmp = $(bigImage_msg_detail_tmp);
      tmp
        .find(".jumpBox")
        .attr("href", h5OpenUrl || "javascript:void(0)")
        .children()
        .attr("src", imgUrl || "");
      break;
    default:
      break;
  }
  tmp.find(".meHeadImg").attr("src", xiaozhuLogo);
  if (text && pluginType !== "botBigImage") {
    tmp.find(".content").html(filterText(text));
    if (h5OpenUrl) {
      if (pluginType === "botText") {
        const tagA = $(
          '<a href class="jumpRoom" targer="_blank">点击前往 ></a>'
        );
        tagA.attr("href", h5OpenUrl || "javascript:void(0)");
        tmp.find(".content").after(tagA);
      } else {
        tmp.find(".jumpImg").attr("href", h5OpenUrl || "javascript:void(0)");
      }
    }
  }
  return tmp;
}

/**
 *
 * @description 过滤文本
 * @param {String} text 需要过滤的文本字符串
 */

function filterText(text) {
  text = text.replace(/(\r\n)|(\\r\\n)|(\n|\\n)|(\r|\\r)/g, "<br/>");
  if (text.match(/(\{(.+)\})/)) {
    text = text.replace(/(\{(.+)\})/, "<b>" + RegExp.$2 + "</b>");
  }
  return text;
}

/**
 *
 *
 * @param {*} msg 接受到的消息
 */
function filterTenantMsg(msg) {
  /**
   * @param {Date <String>} 开始日期
   * @param {Date <String>} 结束日期
   * @param {String} name   用户名
   * @param {String} personCount 入住人数
   * @param {String} purposeTitle 推送消息
   *
   */
  const { beginDate, endDate, name, personCount, purposeTitle } = msg;
  let tips = `${name}，入住人数：${personCount}人，入住时间：${formatDateTime(
    beginDate,
    "md"
  )} - ${formatDateTime(endDate, "md")}，`;
  if (purposeTitle) {
    tips += `来行目的：${purposeTitle}`;
  }
  return tips;
}

/**
 * @desc 过滤refresh的消息,避免多次加载同一个消息
 * @param {Object} msg 消息对象
 */
export function duplicationMsg(msg) {
  const isObject = msg && msg instanceof Object;
  const isValid = isObject && msg.type !== "noop";
  if (isValid) {
    const that = Vue.prototype;
    const userId = that.userInfo.userId; // 获取用户id
    const { toUserId, fromUserId, msgId, luId } = msg;
    const friendId = fromUserId === userId ? toUserId : fromUserId; // 获取会话对方的用户id
    // 获取缓存中的消息列表
    const storageMsgList = getMsg(friendId, luId);
    if (storageMsgList) {
      const isExistMsg = find(storageMsgList, item => +item.msgId === +msgId);
      return !!isExistMsg;
    } else {
      return false;
    }
  } else {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/tools/im.js